const PLAN_KEY = "repman_billing_plan";
const SUBSCRIBER_FREE_USED_KEY = "repman_subscriber_free_used_month";

export const BILLING_PLANS = {
  FREE: "free",
  SUBSCRIBER: "subscriber",
};

function currentMonthKey() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function getBillingPlan() {
  if (typeof window === "undefined") return BILLING_PLANS.FREE;
  const stored = window.localStorage.getItem(PLAN_KEY);
  if (stored === BILLING_PLANS.SUBSCRIBER) return BILLING_PLANS.SUBSCRIBER;
  return BILLING_PLANS.FREE;
}

export function setBillingPlan(plan) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    PLAN_KEY,
    plan === BILLING_PLANS.SUBSCRIBER
      ? BILLING_PLANS.SUBSCRIBER
      : BILLING_PLANS.FREE
  );
}

/** Free deletions still available this month (subscriber). */
export function getSubscriberFreeDeletionsRemaining() {
  if (typeof window === "undefined") {
    return 2;
  }
  const raw = window.localStorage.getItem(SUBSCRIBER_FREE_USED_KEY);
  if (!raw) return 2;
  try {
    const data = JSON.parse(raw);
    if (data.month !== currentMonthKey()) return 2;
    const used = Number(data.used) || 0;
    return Math.max(0, 2 - used);
  } catch {
    return 2;
  }
}

export function consumeSubscriberFreeDeletions(count) {
  if (typeof window === "undefined" || count <= 0) return;
  const remaining = getSubscriberFreeDeletionsRemaining();
  const applied = Math.min(count, remaining);
  const used =
    (() => {
      const raw = window.localStorage.getItem(SUBSCRIBER_FREE_USED_KEY);
      if (!raw) return 0;
      try {
        const data = JSON.parse(raw);
        if (data.month !== currentMonthKey()) return 0;
        return Number(data.used) || 0;
      } catch {
        return 0;
      }
    })() + applied;

  window.localStorage.setItem(
    SUBSCRIBER_FREE_USED_KEY,
    JSON.stringify({ month: currentMonthKey(), used })
  );
}
